const LISTE_TRANSMISSION = {
  title: 'Liste des transmissions',
  interne: 'Facture interne',
  breadcrumb: {
    liste: 'Liste des transmissions',
  },
  actions: {
    affecter: 'Affecter à un factor',
    transmettre: 'Transmettre au factor',
  },
  table: {
    code: 'Facture n°',
    codeDossier: 'Code Dossier',
    etat: 'Etat',
    date: 'Date',
    type: 'Type',
    montantHt: 'Montant HT',
    montantTtc: 'Montant TTC',
    domTom: 'Dom-Tom',
    factor: 'Factor',
    payeur: 'Payeur',
    commercial: 'Commercial(e)',
    datePremierAffichage: 'Date de campagne',
    agence: 'Agence',
    factorDateTransmission: 'Date Transmission',
  },
  type: {
    normal: 'Facture',
    credit: 'Avoir',
    deposit: 'Acompte',
  },
  status: {
    draft: 'Brouillon',
    save: 'Enregistrée',
    cancel: 'Annulée',
    paye: 'Payé',
  },
  filtre: {
    factor: 'Factors',
    sansTiersFactorId: 'Sans factor',
    nonFactorisable: 'Payeur non factorisable',
    factorTransmis: 'Transmis',
    factorDateTransmission: 'Date transmission',
    error: {
      errorfactorDateTransmission: 'La date de fin de la date de transmission est supérieure à la date de début',
    },
  },
  error: {
    noActionSelect: 'Aucune action sélectionnée',
    problemOccurred: 'Un problème est survenu',
  },
  validation: {
    customerAccountingAccountRequired: 'Pour le client {client} des factures {codes} le compte comptable est obligatoire',
    customerCountryRequired: 'Pour le client {client} des factures {codes} le pays est obligatoire.',
    customerSiretRequired: 'Pour le client {client} des factures {codes} le siret est obligatoire.',
    customerZipCodeRequired: 'Pour le client {client} des factures {codes} le code postal est obligatoire.',
    incorrectCustomerCountry: 'Pour le client {client} des factures {codes} le pays "{contry}" est incorrect. Veuillez vérifier l\'orthographe des pays définis par Factofrance.',
    incorrectPaymentType: 'Le mode de règlement "{modeReglement}" des factures {codes} est incorrect.Veuillez vérifier l\'orthographe des modes de règlements définis par Factofrance.',
    orderRequired: 'La facture {code} doit être issue d\'une commande.',
    alreadyTransferred: 'La facture {code} est déjà transmise. Veuillez modifier la facture pour décocher manellement la case transmis',
    paymentTypeRequired: 'Pour l\'écheance de paiement n° : {numEcheance} de la facture {code} le mode de règlement est obligatoire.',
    factorRequired: 'Le factor est obligatoire pour les factures suivantes : {codes}',
    onlyOneFactorAllowed: 'Un seul factor est autorisé à la fois. Les factors sélectionnés sont : {factors}',
    forbiddenToExportDomTomAndFrCustomersAtOnce: 'Interdit d\'exporter des clients dom-tom et des clients français en même temps.',
    paymentTypeFactorExternalCodeRequired: 'Pour Le mode de règlement "{modeReglement}" des factures {codes} le code externe est obligatoire.',
    customerAdressRequired: 'Pour le client {client} des factures {codes} l\'adresse est obligatoire.',
  },
  popUpAffecter: {
    affecter: 'Affecter',
    factor: 'Factor',
    searchFactor: 'Ajouter un factor',
    success: 'La/Les factures ont été affecté(s) à un factor avec succès.',
  },
};

export default LISTE_TRANSMISSION;
